import React, { Component } from 'react'

import classNames from './KeywordList.css'
import { MOBILE_BREAKPOINT } from '../constants'

export default class KeywordList extends Component {
  initialLimit = window.innerWidth < MOBILE_BREAKPOINT ? 10 : 40
  state = {
    limit: this.initialLimit
  }
  toggleLimit = () => {
    const { keywords } = this.props
    const { limit } = this.state
    if (limit === keywords.length) {
      this.setState({
        limit: this.initialLimit
      })
    } else {
      this.setState({
        limit: keywords.length
      })
    }
  }
  renderKeyword = (keyword, index) => {
    const { onClickKeyword, maxCount, r, g, b } = this.props
    const string = typeof keyword === 'object' ? (keyword.name || keyword.key) : keyword
    const onClick = onClickKeyword ? () => onClickKeyword(string, index) : null
    const className = onClickKeyword ? classNames.keywordClickable : classNames.keyword
    let opacity = 0.6
    if (keyword.doc_count && maxCount && maxCount !== 1) {
      opacity = 0.2 + (Math.log(keyword.doc_count) / Math.log(maxCount) * 0.9)
    }
    const backgroundColor = `rgba(${r}, ${g}, ${b}, ${opacity})`
    return (
      <li key={string} className={className} onClick={onClick} style={{ backgroundColor }}>
        {string}
      </li>
    )
  }
  render () {
    const { keywords, r, g, b } = this.props
    const { limit } = this.state
    if (!keywords || keywords.length === 0) {
      return null
    }
    return (
      <ul className={classNames.list}>
        {keywords.slice(0, limit).map(this.renderKeyword)}
        {keywords.length > this.initialLimit &&
          <button className={classNames.button} onClick={this.toggleLimit} style={{ backgroundColor: `rgb(${r}, ${g}, ${b})` }}>
            {keywords.length > limit
              ? '+' + (keywords.length - limit)
              : '-' + (keywords.length - this.initialLimit)
            }
          </button>
        }
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/KeywordList.js